import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Map of block types to custom renderer components.
 *
 * `TEXT` renderers receive `block.text` (may contain `[RESPONSE_SECTION_N]` markers)
 * and `block.entries` (the corresponding inline sections, positionally matched:
 * `entries[0]` = `[RESPONSE_SECTION_1]`, etc.).
 *
 * `DISPLAY_ONLY` renderers receive `block.entries` only — each entry is a
 * standalone section with no surrounding text.
 */

export function createBlockRenderer(renderers, fallback, message) {
  return function renderBlock(block, key) {
    const Renderer = renderers[block.type];
    if (Renderer) return /*#__PURE__*/_jsx(Renderer, {
      block: block,
      message: message,
      renderBlock: renderBlock
    }, key);
    if (fallback) {
      const Fallback = fallback;
      return /*#__PURE__*/_jsx(Fallback, {
        block: block
      }, key);
    }
    return null;
  };
}